import React, { useEffect, useState } from "react";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import { FormattedMessage } from "react-intl";
import Button from "@amzn/meridian/button";
import { CSVLink } from "react-csv";
import { EXPORT_TO_CSV } from "../RouteStatus/utils/Constants";

const ExportCSV = (props) => {
  const csvLink = React.useRef();
  const [csvData, setCSVData] = useState([]);

  useEffect(() => {
    if (csvData.length > 0) {
      csvLink.current.link.click();
    }
  }, [csvData]);

  const exportCSVFile = () => {
    if (props.csvDataProvider) {
      let result = props.csvDataProvider();
      if (Array.isArray(result)) {
        setCSVData(result);
      }
    }
  };

  const fileName =
    props.filePrefix + "_" + new Date().toISOString().slice(0, 10) + ".csv";

  return (
    <div>
      <Row
        width="100%"
        alignmentHorizontal="right"
        spacingInset="none none none none"
        spacing={"none"}
      >
        {props.isLink ? (
          <Link type="secondary" onClick={exportCSVFile}>
            <FormattedMessage
              id="routeStatusTable.exportCSV"
              defaultMessage={EXPORT_TO_CSV}
            />
          </Link>
        ) : (
          <Button type="tertiary" size="small" onClick={exportCSVFile}>
            <FormattedMessage
              id="routeStatusTable.exportCSV"
              defaultMessage={EXPORT_TO_CSV}
            />
          </Button>
        )}
        <CSVLink
          data={csvData}
          ref={csvLink}
          filename={fileName}
          target="_blank"
          fileencoding="UTF-8"
        />
      </Row>
    </div>
  );
};
export default ExportCSV;



// WEBPACK FOOTER //
// ./src/components/ExportCSV/ExportCSV.js